import clsx from 'clsx'
import { useAuth0 } from 'lib/auth'
import { Button, Col, Row } from 'components/common'

export interface HeaderProps {
  title: string
  subtitle?: string
}

const NavHeader = ({ title, subtitle }: HeaderProps): JSX.Element => {
  const logo = 'https://www.gatsbyjs.com/Gatsby-Monogram.svg'
  const { logout, user } = useAuth0()

  // 現在のパスを取得
  const currentPath = window.location.pathname

  // 遷移先を決定
  const returnTo = currentPath.startsWith('/calendar')
    ? window.location.origin + '/login/observer/'
    : window.location.origin

  return (
    <>
      <nav>
        <Row>
          <Col>
            <div className={clsx('table', 'h-full')}>
              <div className={clsx('table-cell', 'align-middle', 'h-full')}>
                <img
                  alt="logo"
                  style={{ width: '100px', height: '50px' }}
                  src={String(logo)}
                />
              </div>
            </div>
          </Col>
          <Col>{title}</Col>
          <Col offset={1}>{subtitle}</Col>
          <Col offset={1} flex="auto">
            <div
              className={clsx('flex', 'flex-auto', 'item-top', 'justify-end')}
            >
              <div className={clsx('mr-4')}>{user?.email}</div>
              <div>
                <Button
                  type="link"
                  onClick={(e) => {
                    e.preventDefault()
                    logout({
                      returnTo: returnTo,
                    })
                  }}
                >
                  ログアウト
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </nav>
    </>
  )
}
export default NavHeader
